export default {
    namespaced: true,
    state: () => ({
      movementInstructionHeader: {},
      movementInstructionLots: {},
      movementInstructionLotBillOfLadingHeaders: {},
      movementInstructionDocuments: {},
      movementInstructionProductSpecs: {},
      movementInstructionMeasureUnits: {},
      movementInstructionAnalysisSamples: {},


      theoreticalLot: {}
    }),
    mutations: {
      setMovementInstructionHeader(state, header){
        state.movementInstructionHeader = header;
      },
      setMovementInstructionLots(state, lots){
        state.movementInstructionLots = lots;
      },
      setMovementInstructionLotBillOfLadingHeaders(state, data){
        state.movementInstructionLotBillOfLadingHeaders[data.lotId] = data.headers;
      },
      setMovementInstructionLotBillOfLadingItems(state, data){
        // TODO - TEMPORANEA, da eliminare quando ci sarà la chiamata in get unica
        if(state.movementInstructionLotBillOfLadingHeaders[data.lotId]){
          for(let i=0; i<state.movementInstructionLotBillOfLadingHeaders[data.lotId].length; i++){
            if(state.movementInstructionLotBillOfLadingHeaders[data.lotId][i].id == data.headerId){
              state.movementInstructionLotBillOfLadingHeaders[data.lotId][i].items = data.items;
            }
          }
        }
      },

      setMovementInstructionProductSpecs(state, data){
        state.movementInstructionProductSpecs[data.lotId] = data.items;
      },
      addMovementInstructionProductSpec(state, data){
        state.movementInstructionProductSpecs[data.lotId].push(data.item);
      },
      deleteMovementInstructionProductSpec(state, data){
        if(data.item.id == null){
          let index = state.movementInstructionProductSpecs[data.lotId].indexOf(data.item);
          if(index > -1){
            state.movementInstructionProductSpecs[data.lotId].splice(index, 1);
          }
        }else{
            // TODO - CANCELLAZIONE SE GIA' SALVATO...
        }
      },

      setMovementInstructionMeasureUnits(state, data){
        state.movementInstructionMeasureUnits[data.lotId] = data.items;
      },
      addMovementInstructionMeasureUnit(state, data){
        state.movementInstructionMeasureUnits[data.lotId].push(data.item);
      },
      deleteMovementInstructionMeasureUnit(state, data){
        if(data.item.id == null){
          let index = state.movementInstructionMeasureUnits[data.lotId].indexOf(data.item);
          if(index > -1){
            state.movementInstructionMeasureUnits[data.lotId].splice(index, 1);
          }
        }else{
            // TODO - CANCELLAZIONE SE GIA' SALVATO...
        }
      },

      setMovementInstructionAnalysisSamples(state, data){
        state.movementInstructionAnalysisSamples[data.lotId] = data.items;
      },
      addMovementInstructionAnalysisSample(state, data){
        state.movementInstructionAnalysisSamples[data.lotId].push(data.item);
      },
      deleteMovementInstructionAnalysisSample(state, data){
        if(data.item.id == null){
          let index = state.movementInstructionAnalysisSamples[data.lotId].indexOf(data.item);
          if(index > -1){
            state.movementInstructionAnalysisSamples[data.lotId].splice(index, 1);
          }
        }else{
            // TODO - CANCELLAZIONE SE GIA' SALVATO...
        }
      },
      clearMovementInstruction(state){
        state.movementInstructionHeader= {};
        state.movementInstructionLots= {};
        state.movementInstructionLotBillOfLadingHeaders= {};
        state.movementInstructionDocuments= {};
        state.movementInstructionProductSpecs= {};
        state.movementInstructionMeasureUnits= {};
        state.movementInstructionAnalysisSamples= {};
      },


      setTheoreticalLot(state, data){
        state.theoreticalLot[data.idMovementInstructionHeder] = data.data;
      },
      resetTheoreticalLot(state){
        state.theoreticalLot = {};
      }

    },
    actions: {
      clearMovementInstruction({commit}, payload){
        commit("clearMovementInstruction", payload)
      },
      setMovementInstructionHeader({commit}, payload){
        commit("setMovementInstructionHeader", payload)
      },
      setMovementInstructionLots({commit}, payload){
        commit("setMovementInstructionLots", payload)
      },
      setMovementInstructionLotBillOfLadingHeaders({commit}, payload){
        commit("setMovementInstructionLotBillOfLadingHeaders", payload)
      },
      setMovementInstructionLotBillOfLadingItems({commit}, payload){
        commit("setMovementInstructionLotBillOfLadingItems", payload)
      },

      
      // PRODUCT SPECS
      setMovementInstructionProductSpecs({commit}, payload){
        commit("setMovementInstructionProductSpecs", payload)
      },
      addMovementInstructionProductSpec({commit}, payload){
        commit("addMovementInstructionProductSpec", payload)
      },
      deleteMovementInstructionProductSpec({commit}, payload){
        commit("deleteMovementInstructionProductSpec", payload)
      },

      
      // MEASURE UNITS
      setMovementInstructionMeasureUnits({commit}, payload){
        commit("setMovementInstructionMeasureUnits", payload)
      },
      addMovementInstructionMeasureUnit({commit}, payload){
        commit("addMovementInstructionMeasureUnit", payload)
      },
      deleteMovementInstructionMeasureUnit({commit}, payload){
        commit("deleteMovementInstructionMeasureUnit", payload)
      },

      // ANALYSIS SAMPLES
      setMovementInstructionAnalysisSamples({commit}, payload){
        commit("setMovementInstructionAnalysisSamples", payload)
      },
      addMovementInstructionAnalysisSample({commit}, payload){
        commit("addMovementInstructionAnalysisSample", payload)
      },
      deleteMovementInstructionAnalysisSample({commit}, payload){
        commit("deleteMovementInstructionAnalysisSample", payload)
      },

      setTheoreticalLot({commit}, payload){
        commit("setTheoreticalLot", payload)
      },
      resetTheoreticalLot({commit}, payload){
        commit("resetTheoreticalLot", payload)
      }
    },
    getters: {
      getTheoreticalLotData: (state) => (idMovementInstructionHeder) => {
        return state.theoreticalLot[idMovementInstructionHeder];
      }
    }
  }